import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
// Layouts
import BlankLayout from '@/layouts/BlankLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';

import LogoutPage from '@/pages/base/LogoutPage/LogoutPage.vue';
import NotFoundPage from '@/pages/guest/NotFoundPage/NotFoundPage.vue';
// Guest Pages
import SalePage from '@/pages/guest/SalePage/SalePage.vue';
import LoginPage from '@/pages/guest/LoginPage/LoginPage.vue';
import ForgotPasswordPage from '@/pages/guest/ForgotPasswordPage/ForgotPasswordPage.vue';
import FormPage from '@/pages/guest/FormPage/FormPage.vue';
import PdfParserPage from '@/pages/guest/PdfParserPage/PdfParserPage.vue';
import LoginAsAdminPage from '@/pages/guest/LoginAsAdminPage/LoginAsAdminPage.vue';
// User Page
import CriticalFutureYearsPage from '@/pages/base/CriticalFutureYearsPage/CriticalFutureYearsPage.vue';
import OverviewPage from '@/pages/base/OverviewPage/OverviewPage.vue';
import PersonalDetailsPage from '@/pages/base/PersonalDetailsPage/PersonalDetailsPage.vue';
import YourDocumentsPage from '@/pages/base/YourDocumentsPage/YourDocumentsPage.vue';
import LatestCommentsPage from '@/pages/base/LatestCommentsPage/LatestCommentsPage.vue';
import CheckYourEntitlementPage from '@/pages/base/CheckYourEntitlementPage/CheckYourEntitlementPage.vue';
import UsefulPhoneNumbersPage from '@/pages/base/UsefulPhoneNumbersPage/UsefulPhoneNumbersPage.vue';
import Have30YearsPage from '@/pages/base/Have30YearsPage/Have30YearsPage.vue';
import HadKidsInTheUKPage from '@/pages/base/HadKidsInTheUKPage/HadKidsInTheUKPage.vue';
import ParentsWorkedInUK from '@/pages/base/ParentsWorkedInUK/ParentsWorkedInUK.vue';
import ContactUsPage from '@/pages/base/ContactUsPage/ContactUsPage.vue';
import BillingPage from '@/pages/base/BillingPage/BillingPage.vue';
import HowToPayPage from '@/pages/base/HowToPayPage/HowToPayPage.vue';
import PrivateUkPensionPage from '@/pages/base/PrivateUkPensionPage/PrivateUkPensionPage.vue';

import ReapplyFormPage from '@/pages/guest/ReapplyFormPage/ReapplyFormPage.vue';
import ReapplyQuestionsPage from '@/pages/guest/ReapplyQuestionsPage/ReapplyQuestionsPage.vue';
import ApplicationAndReapplyPaymentPage from '@/pages/guest/ApplicationAndReapplyPaymentPage/ApplicationAndReapplyPaymentPage.vue';
// import ReapplyPaymentPage from '@/pages/guest/ReapplyPaymentPage/ReapplyPaymentPage.vue';
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth', top: 60 };
    return { top: 0 };
  },
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  routes: [
    {
      path: '/',
      name: 'Sale Page',
      component: SalePage
    },
    {
      path: '/pdf-parser',
      name: 'PDF Parser Page',
      component: PdfParserPage
    },
    {
      path: '/phone',
      name: 'Phone Page',
      component: SalePage
    },
    {
      path: '/form/:id',
      name: 'Form Page',
      component: FormPage
    },
    {
      name: 'Login As Admin',
      path: '/login-as-admin',
      component: LoginAsAdminPage
    },
    {
      name: 'Reapply Form',
      path: '/reapply/form/:id',
      component: ReapplyFormPage
    },
    {
      name: 'Reapply Questions',
      path: '/reapply/questions/:id',
      component: ReapplyQuestionsPage
    },
    {
      name: 'Application And Reapply Payment',
      path: '/application-and-reapply-payment',
      component: ApplicationAndReapplyPaymentPage
    },
    {
      path: '/',
      component: BlankLayout,
      meta: {
        guest: true
      },
      children: [
        {
          name: 'Login',
          path: '/login',
          component: LoginPage
        },
        {
          name: 'Forgot Password',
          path: '/forgot-password',
          component: ForgotPasswordPage
        }
      ]
    },
    {
      path: '/',
      name: 'Home',
      component: DefaultLayout,
      meta: {
        requiresAuth: true
      },
      redirect: '/overview',
      children: [
        {
          name: 'Buying Future Years',
          path: '/buying-future-years',
          component: CriticalFutureYearsPage
        },
        {
          name: 'Overview',
          path: '/overview',
          component: OverviewPage
        },
        {
          name: 'Check Your Entitlement',
          path: '/check-your-entitlement',
          component: CheckYourEntitlementPage
        },
        {
          name: 'How to Pay HMRC to Buy Another Year',
          path: '/how-to-pay',
          component: HowToPayPage
        },
        {
          name: 'Personal Details',
          path: '/personal-details',
          component: PersonalDetailsPage
        },
        {
          name: 'Your Documents',
          path: '/your-documents',
          component: YourDocumentsPage
        },
        {
          name: 'Latest Comments From Us',
          path: '/latest-comments',
          component: LatestCommentsPage
        },
        // {
        //   name: 'Frequently Asked Questions',
        //   path: '/faq',
        //   component: FaqPage
        // },
        {
          name: 'Useful Phone Numbers (HMRC / DWP)',
          path: '/useful-phone-numbers',
          component: UsefulPhoneNumbersPage
        },
        //
        // {
        //   name: 'UK Tax Questions',
        //   path: '/uk-tax-questions',
        //   component: UKTaxQuestionsPage
        // },
        {
          name: 'Have 30+ Years?',
          path: '/have-30-yearc',
          component: Have30YearsPage
        },
        {
          name: 'Private UK Pension?',
          path: '/private-uk-pension',
          component: PrivateUkPensionPage
        },
        // {
        //   name: 'Do You Have a Private UK Pension?',
        //   path: '/private-pension',
        //   component: PrivatePensionPage
        // },
        // {
        //   name: 'Your Personal and Occupational Pensions',
        //   path: '/your-personal-and-occupational-pensions',
        //   component: YourPersonalOccupationalPensionsPage
        // },
        {
          name: 'Had Kids in the UK?',
          path: '/had-kids-in-the-uk',
          component: HadKidsInTheUKPage
        },
        {
          name: 'Parents Worked in UK?',
          path: '/parents-worked-in-uk',
          component: ParentsWorkedInUK
        },
        // {
        //   name: 'Your Friend/Family got a Class 3 Approval Letter but think it’s wrong?',
        //   path: '/class-3-appeals',
        //   component: Class3AppealsPage
        // },
        {
          name: 'Contact Us',
          path: '/contact-us',
          component: ContactUsPage
        },
        {
          name: 'Billing',
          path: '/billing',
          component: BillingPage
        }
      ]
    },
    {
      path: '/logout',
      name: 'Logout',
      component: LogoutPage
    },
    {
      path: '/:pathMatch(.*)*',
      component: NotFoundPage
    }
  ]
});

router.beforeEach((to, _, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters['user/isAuth']) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

router.beforeEach((to, _, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters['user/isAuth']) {
      next('/overview');
      return;
    }
    next();
  } else {
    next();
  }
});
export default router;
